module.exports = __webpack_public_path__ + "img/v-taste.4a0b4ef4.png";